var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("测试文件读取")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}}),_vm._v(" "),_c('a',{attrs:{"href":"javascript:void(null);"},on:{"click":_vm.downloadClicked}},[_vm._v("下载")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7300ddba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/MyTestPage.vue
// module id = null
// module chunks = 